import { create } from "zustand"
import { createJSONStorage, persist } from "zustand/middleware"
import { useMemoizedFn } from "../../hooks/use-memoized-fn"

export type IframeSrcMode = "dev" | "prod" | undefined

type Store = Record<string, IframeSrcMode>

/** Put choice in session storage so that it doesn't reprompt on hot-reload/refresh */
const useIframeSrcModeStore = create<Store>()(
  persist(() => ({}), {
    name: 'iframe-src-mode-v1',
    storage: createJSONStorage(() => sessionStorage)
  })
)

export function useIframeSrcMode(widget: string) {
  const srcMode = useIframeSrcModeStore(s => s[widget])
  const setSrcMode = useMemoizedFn((srcMode: IframeSrcMode) =>
    useIframeSrcModeStore.setState(s => ({
      ...s,
      [widget]: srcMode
    }))
  )
  return [ srcMode, setSrcMode ] as const
}
